// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryPaymentSeedDTO  {
    _originalTypeClassName = "Loom.BO.SalaryPaymentSeedDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryPaymentSeedDTO.translate = translateService;
}
this.Lines = [];
this.Date = null;
this.Month = null;
this.Year = null;
this.PayrollPeriod = null;
this.Type = null;
this.SalaryPaymentSeedDTOKey = null;
this._key = this.SalaryPaymentSeedDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Month:any;
Year:any;
PayrollPeriod:any;
Type:any;
Organisation:any;
Lines:any;
Benefit:any;
private _SalaryPaymentSeedDTOKey:any;
get SalaryPaymentSeedDTOKey(): any {
    return this._SalaryPaymentSeedDTOKey;
  }
set SalaryPaymentSeedDTOKey(value: any) {
    this._SalaryPaymentSeedDTOKey = value;
    this._key = value;
  }
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
}
}
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.SalaryPaymentSeedDTO.removeLines($this, $this.Lines[0]);
                }

                Domain.SalaryPaymentSeedDTO.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SalaryPaymentSeedDTO.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SalaryPaymentSeedDTO.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setBenefit = ($this, value) => {
var oldValue = $this.Benefit;
$this.Benefit = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SalaryPaymentSeedDTOKey == null || $this.SalaryPaymentSeedDTOKey == 0;
            }


}